'use strict';

var qs = require('qs');

const isAndroid = () => !!/Android/g.exec(window.navigator.userAgent);
const invokeWebviewFunction = (name, ...args) => {
    if (isAndroid()) {
        if (args.length > 0) {
            window.cleaninglab[name](...args);
        }
        else {
            window.cleaninglab[name]();
        }
    }
    else {
        if (args.length > 0) {
            window.webkit.messageHandlers[name].postMessage(...args);
        }
        else {
            window.webkit.messageHandlers[name].postMessage('');
        }
    }
};
const encodeParam = (param) => {
    return new URLSearchParams(param).toString();
};
const encodeParamWithQs = (param) => {
    return qs.stringify(param);
};

const changePaymentMethod = (businessType) => {
    invokeWebviewFunction('changePaymentMethod', businessType);
};

const handlePushData = (param, withQs = false) => {
    if (withQs) {
        invokeWebviewFunction('handlePushData', encodeParamWithQs(param));
    }
    else {
        invokeWebviewFunction('handlePushData', encodeParam(param));
    }
};

const sendToNativeLink = (param) => {
    invokeWebviewFunction('sendToNativeLink', param.titleImageUrl, param.titleImageWidth, param.titleImageHeight, param.title, param.contents, param.appLink, param.button1Name, param.button1Link, param.button2Name, param.button2Link);
};

/**
 * TODO: IOS 에 없음 확인필요.
 * @param param
 */
const sendKakaoLink = (param) => {
    invokeWebviewFunction('sendKakaoLink', param.titleImageUrl, param.titleImageWidth, param.titleImageHeight, param.title, param.contents, param.appLink, param.button1Name, param.button1Link, param.button2Name, param.button2Link);
};

/**
 * TODO: IOS 에는 없고 안드로이드에만 있음 디프리케이트 여부 확인
 * @param pushType
 */
const dealWithPushEvent = (pushType) => {
    invokeWebviewFunction('dealWithPushEvent', pushType);
};

/**
 * 그옛날 만든거라 안드와 아이오에스 키와 바디가 모두 다름.
 */
const reserveSchedule = () => {
    if (isAndroid()) {
        invokeWebviewFunction('reserveSchedule');
    }
    else {
        invokeWebviewFunction('cleaninglab', 'reserveSchedule');
    }
};

const shareFacebook = (url) => {
    invokeWebviewFunction(isAndroid() ? 'shareFacebook' : 'shareToFacebook', url);
};

const shareContent = (params) => {
    invokeWebviewFunction('shareContent', qs.stringify(params));
};

const downloadFile = (url) => {
    invokeWebviewFunction('downloadFile', url);
};

const openNewWebView = (url) => {
    invokeWebviewFunction('openNewWebView', url);
};

const openBrowser = (url) => {
    invokeWebviewFunction('openBrowser', url);
};

const closeWebviewWithSuccess = (success) => {
    if (isAndroid()) {
        invokeWebviewFunction('closeWebview', success);
    }
    else {
        invokeWebviewFunction('closeWebview', `some=${success}`);
    }
};

const closeWithCompletion = () => {
    invokeWebviewFunction('closeWithCompletion');
};

const closeWebview = () => {
    invokeWebviewFunction('closeWebview');
};

const haptic = (param) => {
    let args = 2;
    switch (param) {
        case 'SUCCESS':
            args = isAndroid() ? 50 : 0;
            break;
        case 'WARNING':
            args = isAndroid() ? 100 : 1;
            break;
        case 'ERROR':
            args = isAndroid() ? 150 : 2;
            break;
    }
    invokeWebviewFunction('haptic', args);
};

/**
 * TODO: 안드로이드만 파라메터가 있고 IOS 는 없음.
 */
const successCustomerIdentity = (success, errorMessage) => {
    if (isAndroid()) {
        invokeWebviewFunction('successCustomerIdentity', success, errorMessage);
    }
    else {
        invokeWebviewFunction('successCustomerIdentity');
    }
};

/**
 * TODO: 안드로이드에 구현이 없는 이유는?
 */
const didFinishLoaded = () => {
    invokeWebviewFunction('didFinishLoaded');
};

const sendToNativeLinkNoArgs = () => {
    // android user 에는 있음.
    invokeWebviewFunction('sendToNativeLink');
};

const openKakaoTalk = () => {
    invokeWebviewFunction('openKakaoTalk');
};

const openChatRoom = () => {
    invokeWebviewFunction('openChatRoom');
};

const successKakaoPay = (success, errorMessage) => {
    if (isAndroid()) {
        invokeWebviewFunction('successKakaoPay', success, errorMessage);
    }
    else {
        invokeWebviewFunction('successKakaoPay', `${success}&${errorMessage}`);
    }
};

/**
 * TODO: 안드로이드도 구현해야함.
 * @param param
 */
const closeWithHandlePushData = (param, withQs = false) => {
    if (withQs) {
        invokeWebviewFunction('closeWithHandlePushData', encodeParamWithQs(param));
    }
    else {
        invokeWebviewFunction('closeWithHandlePushData', encodeParam(param));
    }
};

/**
@param {string} script 렌더링 완료후 뷰가 뜰때마다 호출해줘야 하는 함수들을 호출하는 코드 ex) "refreshCart();refreshPage();"
 */
const enableOnLoadCallbackScript = (script) => {
    invokeWebviewFunction('enableOnLoadCallbackScript', script);
};

const addTrack = (params) => {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append("event_name", params.event_name);
    if (params.event_param) {
        urlSearchParams.append("event_param", JSON.stringify(params.event_param));
    }
    invokeWebviewFunction('addTrack', urlSearchParams.toString());
};

const hapticWithType = (param) => {
    invokeWebviewFunction('hapticWithType', param);
};

const CleaningWebviewInterfaces = {
    USER: {
        // 공통
        haptic,
        hapticWithType,
        closeWebview,
        closeWithCompletion,
        sendToNativeLink,
        openBrowser,
        openNewWebView,
        openKakaoTalk,
        openChatRoom,
        didFinishLoaded,
        handlePushData,
        closeWithHandlePushData,
        addTrack,
        enableOnLoadCallbackScript,
        // user만
        sendToNativeLinkNoArgs,
        dealWithPushEvent,
        reserveSchedule,
        shareFacebook,
        sendKakaoLink,
        downloadFile,
        closeWebviewWithSuccess,
        successCustomerIdentity,
        successKakaoPay,
        shareContent,
        changePaymentMethod,
    },
    MANAGER: {
        // 공통
        haptic,
        hapticWithType,
        closeWebview,
        closeWithCompletion,
        sendToNativeLink,
        openBrowser,
        openNewWebView,
        openKakaoTalk,
        openChatRoom,
        didFinishLoaded,
        handlePushData,
        closeWithHandlePushData,
        addTrack,
        enableOnLoadCallbackScript,
        // 매니저만
        sendKakaoLink,
    },
};

exports.CleaningWebviewInterfaces = CleaningWebviewInterfaces;
exports.invokeWebviewFunction = invokeWebviewFunction;
